import * as React from "react";
import {
  GridItemChangeEvent,
  GridPageChangeEvent,
  GridPagerSettings,
} from "@progress/kendo-react-grid";
import ResourceTable from "./resources";
import PositionTable from "./positions";
import AppliedResourcesTable from "./aplliedCandidates";
import "./tablestyle.scss";
import { useEffect, useState } from "react";
import { getAPI } from "../../api";
import { REACT_APP_RECRUITER } from "../../utils/common";
import AwardsCertifications from "./awardsCertifications"
import InContract from "./inContract";
import TimeSheet from "./timeSheet";
import CheckHistoryTable from "./checkHistory";


interface AppState {
  items: any;
  total: number;
  skip: number;
  pageSize: number;
  pageable: GridPagerSettings;
}

const Table = (props: any) => {
  
  const [allocatedTo, setAllocatedTo] = useState<any>();


  const createState = (skip: number, take: number, items: any) => {
    let pagerSettings: GridPagerSettings = {
      buttonCount: 20,
      info: true,
      type: "numeric",
      pageSizes: [25, 50, 100],
      previousNext: true,
    };
    return {
      items: items,
      total: props.total && props.total,
      skip: skip,
      pageSize: take,
      pageable: pagerSettings,
    };
  };

  
  const [state, setState] = useState<AppState>(createState(0, 25, props.data));
  const [data, setData] = useState<any>(state.items);

  useEffect(() => {
    if(state)
    {
      setState(createState(state.skip, state.pageSize, props.data));
      setData(state.items)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.total, props.data])
  

  useEffect(() => {

    getAPI( REACT_APP_RECRUITER + "/list").then((response) => {    
      if (response && response.status === 1) {
        setAllocatedTo(response.data)
      }
    }); 
  }, [])
  

  const pageChange = (event: GridPageChangeEvent) => {
    setState(createState(event.page.skip, event.page.take, props.data));
    props.pageSize(event.page.take, event.page.skip)
    
  };

  const itemChange = (event: GridItemChangeEvent) => {

    let field = event.field || "";
    event.dataItem[field] = event.value;
    let newData = data.map((item: any) => {
      if (item.name === event.dataItem.name) {
        item[field] = event.value;
      }
      return item;
    });
    setData(newData);
  };

  const rowClick = (e: any) => {
     
    if(e.dataItem.candidateId){
      let inEdit = true
      let newEdit = false
      let newData = props.data.map((item: any) =>
        item.candidateId === e.dataItem.candidateId ? { ...item, inEdit, allocatedTo } : { ...item, newEdit });
      setState(createState(state.skip, state.pageSize, newData))
    }
    if (e.dataItem.jobId) {
      
      let inEdit = true
      let newEdit = false
      let newData = props.data.map((item: any) =>
        item.jobId === e.dataItem.jobId ? { ...item, inEdit, allocatedTo } : { ...item, newEdit });
      setState(createState(state.skip, state.pageSize, newData))  
    }
  }
  
  const getTables = (type: string) => {
    if (type === 'positions') {
      props.getTablesValues()
    }
    if (type === 'appliedCandidates') {
      props.getAppliedCandidates()
    }
    if (type === 'resources') {
      props.getTablesValues()

    }
  }
  
  
  return (
    <div className="tableStyle">
      {props && props.type === 'resources' && <ResourceTable getResourceTables={() => getTables('resources')} pageChange={pageChange} state={state} data={data} total={props.total} itemChange={itemChange} rowClick={rowClick} hideStatus={props.hideStatus} setSort={props.setSort} applySort={props.applySort}/>  }
      {props && props.type === 'positions' && <PositionTable setSort={props.setSort} draftKey={props.draftKey} getTables={() => getTables('positions')} pageChange={pageChange} state={state} data={data} total={props.total} itemChange={itemChange} rowClick={rowClick}/>  }
      {props && props.type === 'appliedCandidates' && <AppliedResourcesTable  getTables={() => getTables('appliedCandidates')} state={state} data={data} />  }
      {props && props.type === 'awardsCertifications' && <AwardsCertifications data={props.data && props.data} updateAwardCertifications={props.updateAwardCertifications} defaultValues={props.defaultValues} customerId={props.customerId} />}
      {props && props.type === 'incontract' && <InContract data={data} state={state} setSort={props.setSort} applySort={props.applySort}/>}
      {props && props.type === 'timeSheet' && <TimeSheet data={props.data} title={props.title} showHistory={props.showHistory} sendReminder={props.sendReminder}/>}
      {props && props.type === 'checkHistory' && <CheckHistoryTable data={props.data} onClose={props.onClose} sendReminder={props.sendReminder} />}

    </div>
  );
};

export default Table;
